import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { IAdditionalGoodsFilter } from '@/models/store/filter-data/additional-goods-filter.modal';
import { ICaseFilterData } from '@/models/store/filter-data/case-filter.model';
import { IMatFilterData } from '@/models/store/filter-data/mat-filter.model';
import { IAdditionalGood } from '@/models/store/mats-cases/additional-good.model';
import { AdditionalType } from '@/models/store/mats-cases/additional-type.model';
import { IAutoCase } from '@/models/store/mats-cases/auto-case.model';
import { IAdditionFilter } from '@/models/store/mats-cases/filter-data/addition-filter.model';
import { ICaseFilter } from '@/models/store/mats-cases/filter-data/case-filter.model';
import { IMatFilter } from '@/models/store/mats-cases/filter-data/mats-filter.model';
import { IMat } from '@/models/store/mats-cases/mat.model';
import { IMatsCasesState } from '@/models/store/mats-cases/mats-cases-state.model';
import { isEqual } from 'lodash';
import { Module } from 'vuex';
import { store } from '..';

export const matsCasesModule: Module<IMatsCasesState, unknown> = {
    state: {
        mats: [],
        cases: [],
        matsViewItems: [
            'eva_hexagon_beige.jpg',
            'eva_hexagon_black.jpg',
            'eva_hexagon_brown.jpg',
            'eva_hexagon_grey.jpg',
            'eva_hexagon_red.jpg',
            'eva_rhombus_beige.jpg',
            'eva_rhombus_black.jpg',
            'eva_rhombus_grey.jpg',
            'vors_premium_beige.jpg',
            'vors_premium_black.jpg',
            'vors_premium_graphite.jpg',
            'vors_premium_grey.jpg',
            'vors_standart_black.jpg',
            'vors_standart_grey.jpg',
        ],
        additions: [],
        matsCasesFilterData: {
            mats: {
                brands: [],
                carModels: [],
                matTypes: [],
                matFigures: [],
                colors: [],
                located: [],
                carYear: [],
            },
            cases: { caseTypes: [], colors: [], lengths: [], widths: [], heights: [] },
            additions: {
                thrustBearing: { names: [] },
                fastener: { brands: [] },
                partitionWall: { names: [], colors: [] },
                label: { brands: [] },
                edgings: [],
            },
        },
        description: {
            cases: [
                {
                    title: 'Характеристики:',
                    descItems: [
                        {
                            icon: 'mdi-circle',
                            text: 'Состоит из специального трёхслойного материала с добавлением усилителей из пластика для придания ему жёсткости;',
                        },
                        { icon: 'mdi-circle', text: 'Присутствует декоративная отсрочка;' },
                        {
                            icon: 'mdi-circle',
                            text: 'Наличие лейбы с названием марки автомобиля - по желанию;',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'Присутствуют элементы крепления для фиксации всего содержимого во внутреннем пространстве автокейса;',
                        },
                    ],
                },
                {
                    title: 'Преимущества:',
                    descItems: [
                        {
                            icon: 'mdi-circle',
                            text: 'Уникальный дизайн - разработка ООО Аликоста;',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'Оптимальная высота для хранения стеклоомывающей и иных жидкостей в 5-литровых бутылках;',
                        },
                        { icon: 'mdi-circle', text: 'Легкость сборки - наличие инструкции;' },
                        { icon: 'mdi-circle', text: 'Качество пошива - опыт работы более 12 лет;' },
                        {
                            icon: 'mdi-circle',
                            text: 'Возможность персонализации за счёт выбора цвета отсрочки, установки лейбы с названием марки автомобиля, изменения размера;',
                        },
                    ],
                },
                {
                    title: 'Выгода:',
                    descItems: [
                        { icon: 'mdi-circle', text: 'Оптимальное соотношение цена-качество;' },
                        { icon: 'mdi-circle', text: 'Работа напрямую с производителем;' },
                        { icon: 'mdi-circle', text: 'Гарантия, Доставка;' },
                    ],
                },
            ],
            mats: [
                {
                    title: 'Описание',
                    descItems: [
                        {
                            icon: 'mdi-circle',
                            text: 'Благодаря собственному производству Вы можете заказать, как комплект автоковриков  с ковриком в  багажник, так и любой коврик на выбор;',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'Всегда в наличие на выбор черный, серый, бежевый, коричневый цвет. Два вида соты, ромб и шестиугольник;',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'При необходимости коврики фиксируются при помощи липучек (контактной ленты) или специальных  автомобильных креплений (люверсов);',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'На изготовление комплекта уходит от 1 до 2-х дней. В пик заказов до 5-7 дней;',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'Благодаря ячейкам, в которых будет собираться влага, необходимость бортика отсутствует;',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'Один коврик способен в себя вместить около одного литра жидкости;',
                        },
                        {
                            icon: 'mdi-circle',
                            text: 'Уход за ковриками не сложен как собственными силами, при помощи воды и щетки, так же Вам их легко помоют на автомойке;',
                        },
                    ],
                },
            ],
        },
    },

    actions: {
        fetchCases: async ({ commit }, payload: { filter: ICaseFilterData }): Promise<void> => {
            const params = new URLSearchParams();
            if (payload.filter.color) params.append('color', payload.filter.color);
            if (payload.filter.type) params.append('type', payload.filter.type);
            if (payload.filter.length) params.append('length', payload.filter.length);
            if (payload.filter.height) params.append('height', payload.filter.height);
            if (payload.filter.width) params.append('width', payload.filter.width);

            const response = await fetch(`${environment.baseUrl}/api/fetch-data/case?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const data = await response.json();
            commit('setCases', data.data);
        },

        fetchMats: async ({ commit }, payload: { filter: IMatFilterData }): Promise<void> => {
            const params = new URLSearchParams();
            if (payload.filter.color) params.append('color', payload.filter.color);
            if (payload.filter.type) params.append('type', payload.filter.type);
            if (payload.filter.brand) params.append('brand', payload.filter.brand);
            if (payload.filter.carModel) params.append('carModel', payload.filter.carModel);
            if (payload.filter.yearStart) params.append('yearStart', payload.filter.yearStart);
            if (payload.filter.yearEnd) params.append('yearEnd', payload.filter.yearEnd);
            if (payload.filter.located) params.append('located', payload.filter.located);
            if (payload.filter.matFigure) params.append('matFigure', payload.filter.matFigure);
            if (payload.filter._id) params.append('_id', payload.filter._id);

            const response = await fetch(`${environment.baseUrl}/api/fetch-data/mat?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });
            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }
            const data = await response.json();
            commit('setMats', data.data);
        },

        resetMats: ({ commit }, payload: IMat[]): void => {
            commit('setMats', payload);
        },

        fetchAdditions: async (
            { commit },
            payload: { filter: IAdditionalGoodsFilter },
        ): Promise<void> => {
            const params = new URLSearchParams();
            // for type = "partitionWall"
            // if (payload.filter.color)
            //     params.append('color', payload.filter.color);
            if (payload.filter.type) params.append('type', payload.filter.type);
            if (payload.filter.fastenerBrand) params.append('brand', payload.filter.fastenerBrand);
            if (payload.filter.brand) params.append('brand', payload.filter.brand);
            // thrustBearing
            if (payload.filter.name) params.append('name', payload.filter.name);

            const response = await fetch(
                `${environment.baseUrl}/api/fetch-data/addition-good?` + params,
                {
                    method: 'get',
                    headers: {
                        'x-app': 'secret_admin',
                        'Content-type': 'application/json',
                    },
                },
            );

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const data = await response.json();
            commit('setAdditions', data.data);
        },

        additionsEdgingSet({ commit }, payload: IAdditionalGood[]): void {
            commit('setAdditions', payload);
        },

        removeAddition({ commit }, payload: { additionalType: AdditionalType }): void {
            const result: IAdditionalGood[] = store.getters.getAdditionGoods.filter(
                (item: IAdditionalGood) => !isEqual(item.additionalType, payload.additionalType),
            );

            commit('setDefaultAdditions', result);
        },

        fetchCaseFilterData: async ({ commit }): Promise<void> => {
            const response = await fetch(`${environment.baseUrl}/api/filter-data/case`, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const data = await response.json();
            commit('setCasesFilterData', { cases: data.data });
        },

        fetchMatsFilterData: async ({ commit }, payload: IMatFilterData): Promise<void> => {
            const params = new URLSearchParams();
            if (payload.brand) params.append('brand', payload.brand);
            if (payload.carModel) params.append('carModel', payload.carModel);
            if (payload.color) params.append('color', payload.color);
            if (payload.type) params.append('matType', payload.type);
            if (payload.matFigure) params.append('matFigure', payload.matFigure);

            const response = await fetch(`${environment.baseUrl}/api/filter-data/mat?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const data = await response.json();
            commit('setMatsFilterData', { mats: data.data });
        },

        fetchAdditionsFilterData: async ({ commit }): Promise<void> => {
            const response = await fetch(`${environment.baseUrl}/api/filter-data/addition-good`, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const data = await response.json();
            commit('setAdditionFilterData', { additions: data.data });
        },
    },

    mutations: {
        setCases(store, payload: IAutoCase[]): void {
            store.cases = [...payload];
        },

        setMats(store, payload: IMat[]): void {
            store.mats = [...payload];
        },

        setAdditions(store, payload: IAdditionalGood[]): void {
            store.additions = store.additions
                .concat(payload)
                .reduce((prev: IAdditionalGood[], item: IAdditionalGood) => {
                    const repeatEl = prev.find((el: IAdditionalGood) =>
                        isEqual(el.additionalType, item.additionalType),
                    );
                    if (repeatEl) {
                        const curIndex = prev.indexOf(repeatEl);
                        if (!isEqual(curIndex, -1)) prev.splice(curIndex, 1);
                    }

                    if (!prev.find((elem: IAdditionalGood) => isEqual(elem._id, item._id)))
                        prev.push(item);

                    return prev;
                }, []);
        },

        setDefaultAdditions(store, payload: IAdditionalGood[]): void {
            // payload is [], empty array
            store.additions = [...payload];
        },

        setCasesFilterData(store, payload: { cases: ICaseFilter }): void {
            store.matsCasesFilterData.cases = { ...payload.cases };
        },

        setMatsFilterData(store, payload: { mats: IMatFilter }): void {
            store.matsCasesFilterData.mats = { ...payload.mats };
        },

        setAdditionFilterData(store, payload: { additions: IAdditionFilter }): void {
            store.matsCasesFilterData.additions = {
                ...payload.additions,
                edgings: ['Бежевая', 'Красная', 'Белая', 'Черная', 'В цвет'],
            };
        },
    },

    getters: {
        getMats: (store) => store.mats,
        getAutoCases: (store) => store.cases,
        getAdditionGoods: (store) => store.additions,
        getCasesFilterData: (store) => store.matsCasesFilterData.cases,
        getMatFilterData: (store) => store.matsCasesFilterData.mats,
        getAdditionsFilterData: (store) => store.matsCasesFilterData.additions,
        getDescription: (store) => store.description,
        getBaseMats: (store) => store.matsViewItems,
    },
};
